// assets

import { useMemo } from "react";
import { LINKS } from "utils/constant";
import UtiliataireTemplate from "./UtiliataireTemplate";

export const ReportingNavigation = () => {
  const links = useMemo(() => {
    return [
      {
        label: "CODIR",
        to: LINKS.reporting.codir,
      },
      {
        label: "CA",
        to: LINKS.reporting.ca,
      },
      {
        label: "Gestion de stock",
        to: LINKS.reporting.stock,
      },
      {
        label: "Transport de fonds",
        to: LINKS.reporting.operationnelle,
      },
      {
        label: "Parc automobile",
        to: LINKS.reporting.vehicule,
      },
    ];
  }, []);

  return <UtiliataireTemplate links={links} />;
};
